export default __webpack_public_path__ + "static/media/gallery-img-4.fe6ead07.png";